import Column from '@app/components/layout/Column'
import { Text } from '@app/components/core/typography/Text'
import { SelectableTagModel } from '@app/types/TagModel'
import { TagSelect } from '@app/components/core/input/tagSelect/TagSelect'

export type TagSelectionGroupProps<TKey extends string | number> = {
  label: string
  subTitle: string
  tags: SelectableTagModel<TKey>[]
  collapsedAmountVisible?: number
  onSelect: (id: TKey) => void
}

export const TagSelectionGroup = <TKey extends string | number>({
  label,
  subTitle,
  tags,
  collapsedAmountVisible = 5,
  onSelect,
}: TagSelectionGroupProps<TKey>) => {
  return (
    <Column gap={'0.5rem'}>
      <Column gap={0}>
        <Text.Medium isBold={true}>{label}</Text.Medium>
        <Text.Small color={'var(--palette-blue-400)'}>{subTitle}</Text.Small>
      </Column>
      <TagSelect
        tags={tags}
        collapsedAmountVisible={collapsedAmountVisible}
        onSelect={onSelect}
      />
    </Column>
  )
}
